import { ReactNode, createContext, useCallback, useContext, useEffect, useState } from "react";

import { callableFunctions, toastStore, useUser } from "@zickko/client";
import { Org } from "@zickko/shared";

type ContextInfo = {
  org: Org;
};

export const OrgContext = createContext<ContextInfo>({} as any);

type Props = { children: ReactNode };

const OrgProvider = (props: Props) => {
  //
  const { user } = useUser();
  const [org, setOrg] = useState<Org | null | undefined>(undefined);

  const getMyOrg = useCallback(() => {
    setOrg(undefined);
    // get org
    callableFunctions
      .getMyOrg({})
      .then((org) => {
        setOrg(org);
      })
      .catch((e) => {
        toastStore.error("Error getting org.");
        console.error(e);
      });
  }, [user.email]);

  useEffect(() => {
    getMyOrg();
  }, [getMyOrg]);

  if (org === undefined) {
    return <div>Loading org ...</div>;
  }

  if (org === null) {
    return <div>Org not found.</div>;
  }

  return <OrgContext.Provider value={{ org }}>{props.children}</OrgContext.Provider>;
};

function useOrg() {
  return useContext(OrgContext);
}

export { OrgProvider, useOrg };
